export const socialClubMixins = {
	methods: {
		processContentNewline(content) {
			return content ? content.replace(/\\n/g, "").replace(/\n/g, "<br/>") : '';
		},
		autoResizeTextArea(evt) {
			// Reset field height
			evt.target.style.height = 'inherit';
			// Get the height
			const height = evt.target.scrollHeight;
			evt.target.style.height =`${height}px`;
		}
	}
}